module.exports = __webpack_public_path__ + "img/no_data.e3b08d88.png";